import colors from "./theme/colors";
import spaces from "./theme/spaces";

const theme = {
  colors,
  spaces
};

export default theme;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/theme.js